// src/AdminRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const AdminRoute = ({ children }) => {
  const { user, isAdmin, loading } = useAuth() || {};

  if (loading) return <p className="text-center mt-5">Checking permissions...</p>;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <p className="text-center mt-5">Unauthorized: Admins only.</p>;

  return children;
};

export default AdminRoute;
